import type { useCompletedNotificationValues } from './hooks/useCompletedNotificationValues'

export function convertValues(formValues: ReturnType<typeof useCompletedNotificationValues>) {
  return {
    ...formValues,
    includeMessageUnsubscriptionInstructions:
      formValues.notificationWay === 'EMAIL'
        ? formValues.includeMessageUnsubscriptionInstructionsEmail
        : formValues.includeMessageUnsubscriptionInstructionsPhone,
  }
}
